import React, { memo, useState } from "react";
import dayjs from "dayjs";

import { CalendarPicker, DATE_RANGE, DateRange } from "mui-calendar-picker";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function App(): React.ReactElement {
  const [dateRange, setDateRange] = useState<DateRange>(DATE_RANGE);
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CalendarPicker
        setDateRange={setDateRange}
        theme={theme}
        openBtnText={"選擇日期區間"}
        todayBtnText={"今天"}
        confirmBtnText={"確認"}
      />
      <Typography
        sx={{ paddingTop: "1rem", color: theme.palette.primary.main }}
      >
        起始日期：
        {dateRange.start.length > 0 &&
          dayjs(dateRange.start).format("YYYY年MM月DD日")}
      </Typography>
      <Typography sx={{ color: theme.palette.primary.main }}>
        結束日期：
        {dateRange.end.length > 0 &&
          dayjs(dateRange.end).format("YYYY年MM月DD日")}
      </Typography>
    </Box>
  );
}

export default memo(App);
